import axios, { AxiosPromise } from "axios";

import { GROWTH_INSURANCE_API } from "@modules/common/constants";
export type GetClinician = {
  clinician: {
    first_name: string;
    last_name: string;
    title: string;
  };
};

export const getSteadyVisitClinician = (
  consultGuid: string
): AxiosPromise<GetClinician> => {
  return axios.get<GetClinician>(
    `${GROWTH_INSURANCE_API}/v1/consult/${consultGuid}/clinician`
  );
};
